import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useUIStore } from '@/stores/uiStore';

export default function AppLayout() {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const sidebarOpen = useUIStore((s) => s.sidebarOpen);

  return (
    <div className="flex h-dvh flex-col bg-neutral-100">
      {/* Skip navigation link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:bg-primary-600 focus:px-4 focus:py-2 focus:text-black"
      >
        Skip to main content
      </a>

      <Header />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar: visible on desktop, hidden on mobile */}
        {!isMobile && sidebarOpen && (
          <aside className="w-80 flex-shrink-0 border-r border-neutral-300 bg-primary-10">
            <Sidebar />
          </aside>
        )}

        {/* Main content area */}
        <main id="main-content" className="flex-1 overflow-y-auto bg-neutral-200">
          <Outlet />
        </main>
      </div>

      {/* Mobile bottom navigation */}
      {isMobile && <MobileNav />}
    </div>
  );
}
